import React from 'react'
import SiteLayout from '../../component/layout/Layout'
import './timeline.css'
import { Select, Button, Row, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import cardImgTop from '../../assets/img/harzard-scroll.png'
import xboxLogo from '../../assets/img/xbox.svg'
import cardFootericon from '../../assets/img/joint_user.svg'
import heartIcon from '../../assets/img/heart.svg'
import moneyIcon from '../../assets/img/naira.svg'
import vsIcon from '../../assets/img/vs.svg'
import tagIcon from '../../assets/img/tag.svg'

const Timeline = () => {

    const { Option } = Select;

    return(
        <SiteLayout>
            <div className="timeline_header">
                <h1>My Timeline</h1>
            </div>
            <div className="timeline_body">

                <div className="timeline_top_bar">
    
                    <div className="search_by">
                        <p>Filter by</p>
                        <Input.Group compact>
                            <div className="search_preffix">
                                <SearchOutlined />
                            </div>
                            <Select defaultValue="Search Tag">
                                <Option value="Tag2-1">Tag2-1</Option>
                                <Option value="Tag2-2">Tag2-2</Option>
                            </Select>
                        </Input.Group>
                    </div>

                    <div className="favourite">
                        <p>Sort by</p>
                        <Select defaultValue="My Favourite">
                            <Option value="Tag2-1">Tag2-1</Option>
                            <Option value="Tag2-2">Tag2-2</Option>
                        </Select>
                    </div>
                
                </div>

                <div className="timeline_card_holder">
                    <Row gutter={[ 16,24 ]}>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span:6 }}>
                            <div className="card_holder">
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                    

                </div>
            </div>
        </SiteLayout>
    );
}

export default Timeline;